// Stable codes and versioned thresholds are shared by the evaluator and both Members builds.
const family = (key, category, thresholds, names, spanish, unit) =>
  thresholds.map((threshold, i) => ({
    code: `${key}_${threshold}`,
    family: key,
    category,
    threshold,
    unit,
    version: 2,
    name: { "en-GB": names[i], es: spanish[i] },
    presentationKey: `achievements.awards.${key}_${threshold}`,
  }));
export const achievementCatalogue = Object.freeze([
  ...family(
    "membership",
    "membership",
    [1, 5, 10, 20, 25, 50],
    [
      "First Anniversary",
      "Five Years Together",
      "A Decade of Membership",
      "Twenty Years Together",
      "Quarter Century",
      "Fifty Years Together",
    ],
    [
      "Primer aniversario",
      "Cinco años juntos",
      "Una década de pertenencia",
      "Veinte años juntos",
      "Un cuarto de siglo",
      "Cincuenta años juntos",
    ],
    "continuous_years",
  ),
  ...family(
    "heritage",
    "heritage",
    [25, 50, 75, 100],
    [25, 50, 75, 100].map((n) => `Heritage · ${n} Years`),
    [25, 50, 75, 100].map((n) => `Legado · ${n} años`),
    "heritage_years",
  ),
  ...family(
    "golf_rounds",
    "golf",
    [1, 10, 50, 100],
    ["First Tee", "Finding Your Swing", "Fairway Regular", "Century of Rounds"],
    [
      "Primer tee",
      "Encuentra tu swing",
      "Habitual de la calle",
      "Cien vueltas",
    ],
    "rounds",
  ),
  ...family("golf_ace", "golf", [1], ["Hole-in-One"], ["Hoyo en uno"], "ace"),
  ...family(
    "golf_under_par",
    "golf",
    [1],
    ["Under Par"],
    ["Bajo par"],
    "under_par",
  ),
  ...family(
    "racquet_matches",
    "racquet",
    [1, 10, 50, 100],
    ["First Serve", "Into the Rally", "Court Regular", "Century on Court"],
    [
      "Primer saque",
      "Entra en el peloteo",
      "Habitual de la pista",
      "Cien partidos",
    ],
    "matches",
  ),
  ...family(
    "racquet_perfect",
    "racquet",
    [1],
    ["Perfect Match"],
    ["Partido perfecto"],
    "perfect",
  ),
  ...family(
    "events",
    "events",
    [1, 10, 20, 50],
    ["Part of the Club", "Social Circle", "Club Regular", "Social Fixture"],
    [
      "Parte del club",
      "Círculo social",
      "Habitual del club",
      "Presencia habitual",
    ],
    "events",
  ),
  ...family(
    "spa",
    "spa",
    [1, 10, 25],
    ["A Moment for You", "Wellness Ritual", "Time Well Spent"],
    ["Un momento para ti", "Ritual de bienestar", "Tiempo bien dedicado"],
    "treatments",
  ),
  ...family(
    "academy",
    "academy",
    [1, 5],
    ["A New Chapter", "Lifelong Learner"],
    ["Un nuevo capítulo", "Aprendizaje para toda la vida"],
    "programmes",
  ),
]);
export const achievementCategories = [
  "membership",
  "heritage",
  "golf",
  "racquet",
  "events",
  "spa",
  "academy",
];
